import { t } from 'i18next';
import * as yup from 'yup';

import { HaulWareConnection } from '~hooks/useHaulWare/models';

export const haulWareSetupSchema = yup.object().shape({
  apiUser: yup
    .string()
    .trim()
    .required(
      t('form_validation_errors.required', {
        field: t('administration.integration.haul_ware.form.api_user_label'),
      }),
    ),
  apiPassword: yup
    .string()
    .trim()
    .required(
      t('form_validation_errors.required', {
        field: t('administration.integration.haul_ware.form.api_password_label'),
      }),
    ),
  appCode: yup
    .string()
    .trim()
    .required(
      t('form_validation_errors.required', {
        field: t('administration.integration.haul_ware.form.app_code_label'),
      }),
    ),
});

export type HaulWareSetupDto = yup.InferType<typeof haulWareSetupSchema>;

export const haulWareConnectionSchema = yup.object().shape({
  enabled: yup.boolean().required(t('form_validation_errors.required_simple')),
  appCode: yup
    .string()
    .trim()
    .required(
      t('form_validation_errors.required', {
        field: t('administration.integration.haul_ware.form.app_code_label'),
      }),
    ),
  // Blank means "leave the stored password alone"; the PATCH then omits the key.
  apiPassword: yup.string().trim().defined(),
});

export type HaulWareConnectionDto = yup.InferType<typeof haulWareConnectionSchema>;

export const setHaulWareConnectionSchemaDefaultValues = (
  haulWareConnection: HaulWareConnection,
): HaulWareConnectionDto => ({
  enabled: haulWareConnection.enabled,
  appCode: haulWareConnection.appCode,
  apiPassword: '',
});
